<div class="rounded-[50px] p-[40px] update-form relative z-10">
    <form [formGroup]="updateForm" (ngSubmit)="updateProfile()">
        <div class="input-wrapper mx-auto flex flex-col items-center mt-10">
            <mat-form-field appearance="fill" color="primary">
                <mat-label>Name</mat-label>
                <input type="text" matInput formControlName="name">
            </mat-form-field>
            <mat-form-field appearance="fill" color="primary">
                <mat-label>Email</mat-label>
                <input type="email" matInput formControlName="email" #phoneInput>
                <div *ngIf="errors.email" class="text-red-800 text-sm">
                    <div *ngFor="let error of errors.email">{{ error }}</div>
                </div>
            </mat-form-field>
            <mat-form-field appearance="fill" color="primary">
                <mat-label>Phone</mat-label>
                <input type="number" matInput formControlName="phone">
                <!-- <div *ngIf="errors.phone" class="text-red-800 text-sm">
                    <div *ngFor="let error of errors.phone">{{ error }}</div>
                </div> -->
                <div *ngIf="updateForm.get('phone')?.invalid && updateForm.get('phone')?.touched">
                    <small *ngIf="updateForm.get('phone')?.errors?.['required']">Phone number is required.</small>
                    <small *ngIf="updateForm.get('phone')?.errors?.['pattern']">Please enter a valid 10-digit number.</small>
                  </div>
            </mat-form-field>
            <mat-form-field appearance="fill" color="primary">
                <mat-label>Password</mat-label>
                <input type="password" matInput formControlName="password">
            </mat-form-field>
            <div *ngIf="errors.confirmpassword" class="text-red-800 text-sm">
                <div *ngFor="let error of errors.phone">{{ error }}</div>
            </div>
            <div class="button-wrapper mt-4 mb-2">
                <button mat-flat-button color="primary" class="update-btn">Update Profile</button>
            </div>
        </div>
    </form>
</div>